import React from "react";
import Aux from "../utils/AuxFunctions";
import "./Account.css"
import Fire from "../config/Fire";
import { withMyDataContext } from "../context/DataProvider";
import ErrorMessage from "../utils/ErrorPages/ErrorMessage";
import ButtonLoader from "../utils/Utilities/ButtonLoader";
import Colors from "../utils/Colors";
import TextInputMaterial from "../utils/Utilities/TextInputMaterial";
class Username extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            username: "",
            isLoading: false,
            isCreatingUsername: false,
            error: "",
        }
    }

    onSubmit = async () => {
        const {username} = this.state
        if (this.state.isLoading) {
            return;
        }

        this.setState({ isLoading: true, isCreatingUsername: true, error: "" })
        try {
            if (username.length < 5) {
                this.setState({ isLoading: false, error: "too short" });
                return;
            } else if(/[^A-Z0-9._-]/gi.test(username)) {
                this.setState({ isLoading: false, error: 'username can only have ".", "-" and "_"' });
                return;
            }
            /*
            instrucoes nao foram claras, acabei na prisao por andar a rebolar nu na rua a coberto de vaselina a pensar q era uma lesma 
            */

            /*
            as tuas instrucoes nao foram claras, acabei de sacrificar 2 ovelhas para resuscitar o hitler, q agora tem o nome de Andre Ventura 
            */
            let userAvailable = await Fire.shared.CheckIfUsernameExists(this.state.username.toLowerCase())
            if (!userAvailable) {
              this.setState({error: "Username already exists", isLoading:false})
              return;
            } else {
                await Fire.shared.createUserAuth(username).then(didCreate => {
                    if(didCreate){
                        this.props.myDataProvider.init();
                        this.props.history.push({
                            pathname: "/account/edit",
                            state: { addInfo: true }
                          })
                        //this.props.navigation.navigate('EditProfile', { isStart: true })
                    }else{
                        this.setState({ isLoading: false, error: "an unexpected error has occurred" });
                    }
                })
              this.setState({ isLoading: false })
              return;
            }
        } catch(error){
            Aux.handleError(error)
        }
    }

    onChanged(text) {
        //let num = text.replace(/[^0-9]/g, '')
        let username = text.replace(/[^a-zA-Z0-9-_.*$]/g, '')
        this.setState({username: username, error:""});
    }


    render() {
        const error = this.state.error;
        
        return (
            <div style={{width:"100%"}}>
                <section className="container login">
                    <h2 style={{marginTop:10}}>Welcome to Richless</h2>
                    <span style={{color:Colors.softText, marginTop:20}}>Final step</span>
                    <div style={{marginTop:20}}>
                        <ErrorMessage text={error}></ErrorMessage>
                        
                        {this.props.myDataProvider.user && this.props.myDataProvider.user.username && !this.state.isCreatingUsername? 
                        <div style={{display:"flex", justifyContent:"center"}}>
                            <span>You're already registered.</span>
                        </div> 
                        :
                        <div>
                            <div style={{margin:"20px 0"}}>
                                <span style={{color:"#777", fontSize:14}}>To complete the registration add a valid username</span>
                            </div>
                        <TextInputMaterial type="text" placeholder="Username" maxLength={30}
                            styleInput={{borderColor: this.state.error ? "red" : ""}}
                            onChange={(e) => {
                                this.onChanged(e.target.value)
                            }}/>

                        <ButtonLoader 
                            text="Create Account" 
                            loading={this.state.isLoading} 
                            style={{backgroundColor: Colors.mainColor, width:"100%", height:45, marginTop:20}}
                            // icon={FacebookIcon}
                            onClick={this.onSubmit}
                        ></ButtonLoader> 
                        </div>
                        }
                    </div>

                </section>
            </div>
        );
    }
}

export default withMyDataContext(Username);